import { c as _c } from "react/compiler-runtime";
import { tv } from 'tailwind-variants';
import { base } from './base';
import type { ComponentPropsWithRef } from 'react';
import type { VariantProps } from 'tailwind-variants';
const display = tv({
  extend: base,
  base: 'font-aeonik',
  variants: {
    size: {
      xl: 'text-[4.0625rem] leading-16',
      lg: 'text-[3rem] leading-13',
      md: 'text-[2.25rem] leading-11',
      sm: 'text-[2rem] leading-9.5'
    }
  },
  defaultVariants: {
    size: 'md'
  }
});
export type DisplayVariants = VariantProps<typeof display>;
const SIZE_TO_ELEMENT = {
  xl: 'h1',
  lg: 'h1',
  md: 'h1',
  sm: 'h2'
} as const;
type DisplayProps = ComponentPropsWithRef<'h1'> & DisplayVariants;
function Display(t0) {
  const $ = _c(19);
  let className;
  let disabled;
  let italic;
  let rest;
  let t1;
  let tracking;
  let weight;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      weight,
      italic,
      disabled,
      tracking,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = italic;
    $[4] = rest;
    $[5] = t1;
    $[6] = tracking;
    $[7] = weight;
  } else {
    className = $[1];
    disabled = $[2];
    italic = $[3];
    rest = $[4];
    t1 = $[5];
    tracking = $[6];
    weight = $[7];
  }
  const size = t1 === undefined ? "md" : t1;
  const Element = SIZE_TO_ELEMENT[size];
  let t2;
  if ($[8] !== className || $[9] !== disabled || $[10] !== italic || $[11] !== size || $[12] !== tracking || $[13] !== weight) {
    t2 = display({
      size,
      weight,
      italic,
      disabled,
      tracking,
      class: className
    });
    $[8] = className;
    $[9] = disabled;
    $[10] = italic;
    $[11] = size;
    $[12] = tracking;
    $[13] = weight;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== Element || $[16] !== rest || $[17] !== t2) {
    t3 = <Element className={t2} {...rest} />;
    $[15] = Element;
    $[16] = rest;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
}
export { display, Display };